import { CookieSetOptions } from 'universal-cookie';
import servers from '../utils/servers';

// Security options for production/staging environments
export const secureOptions = {
  sameSite: 'none',
  secure: true,
} as const;

export function getDefaultCookieOptions(): CookieSetOptions {
  return {
    ...(process.env.NODE_ENV !== 'development' ? secureOptions : {}),
    domain: servers.cookieDomain,
    path: '/',
  };
}
